import { observer } from 'mobx-react';

import { useStore } from '@assets/model/Store';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { StorageUpload } from '../StorageUpload/StorageUpload';
import * as style from './UploadDeal.module.less';
export const UploadDeal = observer(() => {
    return (
        <StorageUpload
            display="New Deal"
            storageTarget={{ type: 'cim' }}
            toasterMessage="Uploading Deal: %name%"
            className={style.newDealButton}
            onUpload={fileName => {
                const fb = getFirebase();
                fb.store_audit_entry('UPLOAD_CIM', { fileName });
                fb.add_job(fileName);
            }}
        ></StorageUpload>
    );
});
